// Renders inline key data (dates, names, numbers) with gold semibold tabular treatment.
export default function KeyData({ children, as = "span", className = "" }) {
  const Tag = as;
  return <Tag className={`key-data ${className}`}>{children}</Tag>;
}
